import React from 'react'

import { receivingContext, ReceivingFlowController } from '../flow'
import { ActionButton, RfShell } from '../components/RfShell'
import { AsnSummary } from '../components/AsnSummary'
import { RfStatusBanner } from '../components/RfStatusBanner'
import { TaskHeader } from '../styles'

interface ConfirmAsnScreenProps {
  controller: ReceivingFlowController
  embedded?: boolean
  onExit: () => void
}

export const ConfirmAsnScreen = ({ controller, embedded = false, onExit }: ConfirmAsnScreenProps) => {
  const { state, dispatch } = controller
  if (!state.selectedAsn) return null

  return (
    <RfShell
      title="Receiving"
      phase="Identify ASN"
      embedded={embedded}
      contextSummary={receivingContext(state)}
      contextDetails={null}
      onBack={() => dispatch({ type: 'back' })}
      moreActions={[{ label: 'Exit receiving', onSelect: onExit, danger: true }]}
      actions={
        <ActionButton type="button" disabled={state.sectionComplete} onClick={() => dispatch({ type: 'confirm-asn' })}>
          {state.sectionComplete ? 'ASN identified' : 'Confirm ASN'}
        </ActionButton>
      }
    >
      {state.status ? <RfStatusBanner tone={state.status.tone}>{state.status.message}</RfStatusBanner> : null}
      <TaskHeader>
        <h1>Confirm ASN</h1>
        <p>Verify that the shipment paperwork matches the selected ASN.</p>
      </TaskHeader>
      <AsnSummary asn={state.selectedAsn} />
    </RfShell>
  )
}
